
import { Component, OnInit, Renderer2, EventEmitter, OnDestroy, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { LoginService } from 'src/app/services/login.service';
import { InsightsService } from 'src/app/shared/insights/service/insights.service';
import { SidePanelService } from 'src/app/shared/services/side-pannel/side-pannel.service';
import { SharedataService } from 'src/app/shared/share/service/sharedata.service';
import { ExcelViewerService } from '../service/excel-viewer.service';
import { ReportService } from '../service/report.service';
import { TrackerService } from '../service/tracker.service';
import { HomeService } from "src/app/shared/services/home.service";
import { ToplineService } from '../service/topline.service';
import { RepoApiService } from '../service/repo-api.service';
import { NotifierService } from 'angular-notifier';
// declare let $: any;

@Component({
  selector: 'app-excel-viewer',
  templateUrl: './excel-viewer.component.html',
  styleUrls: ['./excel-viewer.component.scss']
})
export class ExcelViewerComponent implements OnInit, OnDestroy {

  eventsDownload: Subject<any> = new Subject<any>();
  public selectedFilter: any = [];
  public selectedKpiKeys: any = [];
  // public selectedKpiFilter: any = [];
  public filterRef;
  public kpiFilters:any = {};
  public excelFileDetails:any;
  public filterInputElementList:any[] = [];
  public isSheetChanges:boolean = false;
  // public hasFilters:boolean = false;
  
  constructor(public reportService: ReportService,
    public evService: ExcelViewerService,
    private aRout:ActivatedRoute,
    private sidePanelService:SidePanelService,
    private router: Router,
    private repoService:RepoApiService,
    private notifier:NotifierService, 
    public iService:InsightsService,
    public sService:SharedataService,
    public trackerService:TrackerService,
    private loginService: LoginService,
    private homeService: HomeService,
    public toplineService:ToplineService,
    private readonly renderer: Renderer2) { 
      this.aRout.params.subscribe(param => {
        // this.excelFileDetails = localStorage.getItem('excelfile');
        // this.reportService.projectDetails = localStorage.getItem('reportdetails');
        // if(this.excelFileDetails && this.reportService.projectDetails){
        //   this.reportService.projectDetails = JSON.parse(this.reportService.projectDetails);
        //   this.excelFileDetails = JSON.parse(this.excelFileDetails);
        //   // console.log('reportdetails : ', this.reportService.projectDetails);
        // }else{
        //   this.router.navigate(['/home/repository-report/details/'+param['uuid']]);
        // }
        // console.log('param : ', param);
        this.evService.fileUUID = param['uuid'];
        if (!(this.reportService.studyId && this.reportService.studyId !="")) {
          this.reportService.getRepositoryDetailByFile(param['uuid'])
        }
        // this.homeService.isOpen = false;
        // this.sidePanelService.initSideDrawer('repo');
        // this.evService.getExcelData();
        this.toplineService.setExcelviewerFileUUID(this.evService.fileUUID);
        this.evService.getFilterOptions();
      })

    };




  ngOnInit() {
    this.evService.accessRoles = JSON.parse(localStorage.getItem('access'))["access_rules"];
    // console.log("this.evService.accessRoles ===>",this.evService.accessRoles)
    this.isSheetChanges = false;
    this.filterRef = document.getElementById('filtersID');
    // let user = this.reportService.reportDetails.project_name
    
    this.evService.excelDataSUb1.subscribe((value) => {
      if (Object.keys(this.evService.selectedSheet).length) {
        this.renderer.setProperty(this.filterRef, 'innerHTML','');
        let data = this.evService.allFilters[this.evService.selectedSheet['key']]['filters'];
        this.kpiFilters = this.evService.allFilters[this.evService.selectedSheet['key']]['kpis'];
        this.isSheetChanges = true;
        this.createFilters(this.filterRef,data);
      }

      // if (!this.isSheetChanges && Object.keys(this.evService.selectedSheet).length) {
      //   this.renderer.setProperty(this.filterRef, 'innerHTML','');
      //   let data = this.evService.allFilters[this.evService.selectedSheet['key']]['filters'];
      //   // this.hasFilters = Object.keys(this.evService.allFilters[this.evService.selectedSheet['key']]['filters']).length ? true :false;
      //   this.kpiFilters = this.evService.allFilters[this.evService.selectedSheet['key']]['kpis'];
      //   this.isSheetChanges = true;
      //   this.createFilters(this.filterRef,data);
      // }
    });

    // this.reportService.setExcelFileViewerEvent.subscribe((data) => {
    //   this.excelFileDetails = data['fileObj'];
    //   this.evService.setExcelData(data);
    // })

  }

  addNewSheet(){
    this.evService.addNewSheet();
    this.evService.currentOpeningSheetIndex = this.evService.allSheetsName.length-1;
    this.renderer.setProperty(this.filterRef, 'innerHTML','');
  }

  selectSheet(sheet,index){
    if (sheet.value.isNewSheet) {
      // this.evService.selectedSheet = sheet;
      this.renderer.setProperty(this.filterRef, 'innerHTML','');
      this.evService.selectBlankSheet(sheet);
    }else{
      this.isSheetChanges = true;
      this.evService.selectSheet(sheet);
      this.selectedFilter = []
      this.renderer.setProperty(this.filterRef, 'innerHTML','');
      this.evService.currentOpeningSheetIndex = index;
  
      // let data = this.evService.allFilters[this.evService.selectedSheet['key']]['filters'];
      // this.kpiFilters = this.evService.allFilters[this.evService.selectedSheet['key']]['kpis'];
      // setTimeout(()=>{
      //   this.createFilters(this.filterRef,data);
      // })
    }
  }

  ngOnDestroy() {
    this.evService.selectedSheet = {};
    this.toplineService.setCrosstabFileUUID("");
    // if (!this.router.url.includes('repository-report/topline/alias')) {
    if (!this.router.url.includes('topline/report/alias')) {
      this.toplineService.setExcelviewerFileUUID("");
    }
    this.resetFilterView()
    this.evService.resetTableView();
    this.loginService.isSessionLoggedOut().subscribe((result) => {
      if(result['message'] == 'success') {
        this.submitTracker();
      }
    })
    this.evService.closeKPIReorder();
    // this.submitTracker();
  }

  resetFilterView(){
    this.renderer.setProperty(this.filterRef, 'innerHTML','');
  }
  // insertKey(key,value,obj,pos){
  //   return Object.keys(obj).reduce((ac,a,i) => {
  //     if(i === pos) ac[key] = value;
  //     ac[a] = obj[a]; 
  //     return ac;
  //   },{})
  // }

  public interval: number = 0;
  public timer;
  startTimer(){
    this.stopTimer();
    this.timer = setInterval(() => {
      this.interval++;
      // console.log("focused in viewer ", this.interval)
    },1000);
  }
  stopTimer(){
    clearInterval(this.timer);
    // console.log("blure in viewer ", this.interval)
  }
  @HostListener('window:focus', ['$event'])
  onFocused(event) {
    this.startTimer();
  }
  @HostListener('window:blur', ['$event'])
  onBlur(event) {
    this.stopTimer();
  }
  @HostListener('window:beforeunload',['$event'])
  unload(event)
  {
          event.preventDefault();
          event.returnValue = false;
          this.loginService.isSessionLoggedOut().subscribe((result) => {
            if(result['message'] == 'success') {
              this.submitTracker();
            }
          })
          // this.submitTracker();
  }

  // breadcrumbClick(index){
  //   switch(index){
  //     case 1 : if(this.reportService.isQual){
  //       this.router.navigate(['home/qual/report/',this.evService.studyUUID]);
  //     }
  //     else{
  //       this.router.navigate(['home/repository-report/details/',this.evService.studyUUID]);
  //     }
  //     break;

  //     case 2 : if(this.reportService.isQual){
  //       this.router.navigate(['home/qual/interview/',this.evService.studyUUID]);
  //     }
  //     else{
  //       this.router.navigate(['home/repository-report']);
  //     }
  //     break;
  //     case 3 : 
  //       this.router.navigate(['home/repository-report/details',this.evService.studyUUID]);
  //     break;
  //   }
  // }


  breadcrumbClick(index){
    switch(index){
      case 1 : if(this.reportService.isQual){
        this.router.navigate(['qual/report/',this.reportService.studyId]);
        // this.router.navigate(['home/qual/report/',this.reportService.studyId]);
      }
      else{
        this.router.navigate(['repo/details/',this.reportService.studyId]);
        // this.router.navigate(['home/repository-report/details/',this.reportService.studyId]);
      }
      break;

      case 2 : if(this.reportService.isQual){
        this.router.navigate(['qual/interview/',this.reportService.studyId]);
        // this.router.navigate(['home/qual/interview/',this.reportService.studyId]);
      }
      else{
        this.router.navigate(['repo']);
        // this.router.navigate(['home/repository-report']);
      }
      break;
    }
  }

  showCommentPanel(){
    this.iService.openInsight(this.reportService.fileUUID,'file',"this.requestService.requestDetails.title");
  }
  showSharePanel(){
    this.sService.openSharePanel(this.reportService.fileUUID,'file');
  }

  download(type){
    switch (type) {
      case 'all-tabs':
        this.reportService.detailsUUID = this.reportService.fileUUID;
        this.reportService.downloadFile().subscribe(result =>{
          if(result['status'] == 1){
            this.downloadFile(result['url'][0]);
          }
          if(result['status'] == 4){
            this.notifier.notify("error",result['message']);
            this.sidePanelService.afterLoginNavigate();
          }
          this.reportService.isLoading = false;
        }, error => {
          console.log('error : ', error);
          this.reportService.isLoading = false;
        })
        break;
      case 'opened-kpi':
        this.eventsDownload.next({"type":"opened-kpi"})
      break;
      case 'opened-tab':
        this.eventsDownload.next({"type":"opened-tab"})
      break;
      default:
        break;
    }
  }

  downloadFile(url){
    let ahref:HTMLElement = document.getElementById('downloadFIleURL');
    const data = url;
    ahref.setAttribute('href', url);
    ahref.setAttribute('target', '_blank');
    ahref.setAttribute('download', this.reportService.fileName+'.'+this.reportService.fileType);
    ahref.click();
  }


  changeViewFormet(){
    
  }

  onSelectKpiFilter(filter: string, event, checkBox:HTMLInputElement, outerParentElement: HTMLElement) {
    event.stopPropagation();
    setTimeout(() => {
      const index = this.selectedKpiKeys.indexOf(filter);
      if (false) {

      } else {
        if (index == -1) {
          this.selectedKpiKeys.push(filter);
          checkBox.checked = true;
        } else {
          this.selectedKpiKeys.splice(index, 1);
          checkBox.checked = false;
        }
      }
      if (this.selectedKpiKeys.length) {
        let selectedKpiStr = '';
        this.selectedKpiKeys.forEach(key => {
          selectedKpiStr += key+', '
        });
        this.renderer.setProperty(outerParentElement, 'placeholder',selectedKpiStr.slice(0, -2));
      }else{
        this.renderer.setProperty(outerParentElement, 'placeholder','Show KPI\'s');
      }
    });
  }

  onSelectFilter(filter: string, event, checkBox:HTMLInputElement,parentElement:HTMLDivElement, groupElement?: HTMLDivElement) {
    event.stopPropagation();
    console.log("selected filters ===>",this.selectedFilter)
    setTimeout(() => {
      const index = this.selectedFilter.indexOf(filter);
      if (groupElement) {
        if (index == -1) {
          this.selectedFilter.push(filter);
          checkBox.checked = true;
          this.onSelectGroupFilter(groupElement,true)
        } else {
          this.selectedFilter.splice(index, 1);
          checkBox.checked = false;
          this.onSelectGroupFilter(groupElement,false)
        }
      } else {
        if (index == -1) {
          this.selectedFilter.push(filter);
          checkBox.checked = true;
        } else {
          this.selectedFilter.splice(index, 1);
          checkBox.checked = false;
          let parent = filter.substring(0,filter.lastIndexOf('--.-')) + ''
          let parentIndex = this.selectedFilter.indexOf(parent);
          if (parentIndex != -1) {
            this.selectedFilter.splice(parentIndex, 1);
            let temp = parent.split('--.-');
            let parentClass = temp[temp.length - 1].replace(/\s+/g, '-').trim()
            // let parentCheckbox = document.getElementsByClassName(parentClass)[0];
            let parentCheckbox = parentElement.getElementsByClassName(parentClass)[0];
            if (parentCheckbox) {
              parentCheckbox['checked'] = false;
            }
          }
        }
      }
      setTimeout(()=>{
        this.getParentSelectedArray(this.selectedFilter,filter)
      })
    });
  }

  getParentSelectedArray(selectedFilter, currentFilter){
    let currentFilterKey = currentFilter.split('--.-')[0];
    let currentFilterName = currentFilterKey.split('$$$$')[1];
    let selectedFilterStr = ''
    selectedFilter.forEach(item => {
      let temp = item.split('--.-');
      if (temp && temp.length && currentFilterKey == temp[0]) {
        let tempFilterStr = temp[temp.length - 1].split('$$$$')[1]
        selectedFilterStr += tempFilterStr + ', ';
        // selectedFilterStr += temp[temp.length - 1] + ', ';
      }

    });
    let filterInputElement = this.filterInputElementList.find(element =>{
      return element.key == currentFilterKey
    });
    this.renderer.setProperty(filterInputElement.element,'placeholder',selectedFilterStr.slice(0, -2))
    if (selectedFilter.length == 0) {
    this.renderer.setProperty(filterInputElement.element,'placeholder',currentFilterName)
    }
    // console.log(selectedFilterStr);
  }

  onSelectGroupFilter(groupElement,isAdd){
    // key.replace(/\s+/g, '-').trim()
    let childFilters = groupElement.getElementsByClassName('filter-input-checkbox');
    if (isAdd) {
      for (let i = 0; i < childFilters.length; i++) {
        childFilters[i].checked = true;
        const itemIndex = this.selectedFilter.indexOf(childFilters[i].attributes['datakey']['nodeValue']);
        if (itemIndex == -1) {
          this.selectedFilter.push(childFilters[i].attributes['datakey']['nodeValue']);
        }
      }
    }else{
      for (let i = 0; i < childFilters.length; i++) {
        const index = this.selectedFilter.indexOf(childFilters[i].attributes['datakey']['nodeValue']);
        childFilters[i].checked = false;
        this.selectedFilter.splice(index, 1);
      }
    }
  }

  createFilters(elmRef:HTMLDivElement, filter:any){
    const filterContainer = this.renderer.createElement('div');
    this.renderer.appendChild(elmRef, filterContainer);
    this.renderer.addClass(filterContainer, 'filter-main-container');
    this.drawKpiFilter(filterContainer);
    Object.keys(filter).forEach(fkey =>  {
      const filters = this.renderer.createElement('div');
      const filterWrap = this.renderer.createElement('div');
      const filterHead = this.renderer.createElement('div');
      const filterInput = this.renderer.createElement('INPUT');
      const filterToggel = this.renderer.createElement('i');
      const rowsToggle = this.renderer.createElement('div');
      const moreFiltersContainer = this.renderer.createElement('div');
      this.renderer.addClass(filterWrap, 'filter-wrap');
      this.renderer.addClass(filters, 'filters-list');
      this.renderer.addClass(moreFiltersContainer, 'more-filters-container');
      this.renderer.addClass(moreFiltersContainer, 'outer-filters-toggel');
      this.renderer.addClass(filters, 'filter-v2');
      this.renderer.addClass(filterInput, 'filter-input');
      this.renderer.addClass(filterHead, 'filter-head');
      this.renderer.addClass(filterToggel, 'filter-toggel');
      this.renderer.addClass(filterToggel, 'outer-filters-toggel-icon');
      this.renderer.addClass(filterToggel, 'material-icons');
      this.renderer.addClass(filterToggel, 'row-toggle-icon');
      this.renderer.appendChild(filterToggel, this.renderer.createText('arrow_drop_down'));
      this.renderer.appendChild(rowsToggle, filterToggel);
      this.renderer.appendChild(filterHead, filterInput);
      this.renderer.appendChild(filterHead, rowsToggle);
      this.renderer.setStyle(filterInput, 'cursor', 'pointer');
      this.renderer.setStyle(rowsToggle, 'cursor', 'pointer');
      this.renderer.setProperty(filterInput, 'readOnly','true');
      this.renderer.setProperty(filterInput, 'placeholder',filter[fkey]["name"]);
      // this.renderer.setProperty(filterInput, 'placeholder',fkey);
      // this.renderer.setProperty(filterInput, 'tooltip',fkey);
      this.renderer.appendChild(filterInput, this.renderer.createText(JSON.stringify(this.selectedFilter)));
      this.renderer.listen(rowsToggle, 'click', (event) => { this.toggleRow(filterToggel, moreFiltersContainer, event , 'outer-parent') });
      this.renderer.listen(filterInput, 'click', (event) => { this.toggleRow(filterToggel, moreFiltersContainer, event,'outer-parent') });
      this.renderer.appendChild(filterContainer, filterWrap);
      this.renderer.appendChild(filterWrap, filterHead);
      this.renderer.appendChild(filterWrap, filters);
      this.renderer.appendChild(filters, moreFiltersContainer);
      this.renderer.setStyle(moreFiltersContainer, 'display','none');
      this.filterInputElementList.push({'element':filterInput,'key':fkey+"$$$$"+filter[fkey]["name"]})
      this.drawFilters(moreFiltersContainer, filter[fkey]['options'],fkey+"$$$$"+filter[fkey]["name"],filterWrap);
    })
  }

  drawKpiFilter(elmRef: HTMLDivElement){
    const filters = this.renderer.createElement('div');
    const filterWrap = this.renderer.createElement('div');
    const filterHead = this.renderer.createElement('div');
    const filterInput = this.renderer.createElement('INPUT');
    const filterToggel = this.renderer.createElement('i');
    const rowsToggle = this.renderer.createElement('div');
    const moreFiltersContainer = this.renderer.createElement('div');

    this.renderer.addClass(filterInput, 'filter-input');
    this.renderer.addClass(filterToggel, 'filter-toggel');
    this.renderer.addClass(filterToggel, 'outer-filters-toggel-icon');
    this.renderer.addClass(filterToggel, 'material-icons');
    this.renderer.addClass(filterToggel, 'row-toggle-icon');
    this.renderer.addClass(filterHead, 'filter-head');
    this.renderer.addClass(filterWrap, 'filter-wrap');
    this.renderer.addClass(moreFiltersContainer, 'more-filters-container');
    this.renderer.addClass(moreFiltersContainer, 'outer-filters-toggel');
    this.renderer.addClass(filters, 'filters-list');

    this.renderer.appendChild(filterToggel, this.renderer.createText('arrow_drop_down'));
    this.renderer.appendChild(rowsToggle, filterToggel);
    this.renderer.appendChild(filterHead, filterInput);
    this.renderer.appendChild(filterHead, rowsToggle);
    this.renderer.appendChild(filterWrap, filterHead);
    this.renderer.appendChild(filterWrap, filters);
    this.renderer.appendChild(filters, moreFiltersContainer);
    this.renderer.appendChild(elmRef, filterWrap);

    this.renderer.setStyle(moreFiltersContainer, 'display','none');
    this.renderer.setStyle(filterInput, 'cursor', 'pointer');
    this.renderer.setStyle(rowsToggle, 'cursor', 'pointer');

    this.renderer.setProperty(filterInput, 'readOnly','true');
    this.renderer.setProperty(filterInput, 'placeholder','Show KPI\'s');
    // this.filterInputElementList.push({'element':filterInput,'key':'Show KPI\'s'})

    this.renderer.listen(rowsToggle, 'click', (event) => { this.toggleRow(filterToggel, moreFiltersContainer, event , 'outer-parent') });
    this.renderer.listen(filterInput, 'click', (event) => { this.toggleRow(filterToggel, moreFiltersContainer, event,'outer-parent') });
    let parent = 'Show Kpi'
    Object.keys(this.kpiFilters).forEach(fkey =>{
      const Hrow = this.renderer.createElement('div');
      const checkBox = this.renderer.createElement('INPUT');
      const Hcell = this.renderer.createElement('div');
      checkBox.setAttribute("type", "checkbox");
      this.renderer.appendChild(Hrow, checkBox);
      this.renderer.appendChild(Hrow, Hcell);
      this.renderer.addClass(Hrow, 'filter-item');


      // checkBox.setAttribute("datakey", fkey);
      checkBox.setAttribute("datakey", this.kpiFilters[fkey]["name"]);
      this.renderer.setStyle(Hrow, 'cursor', 'pointer');
      this.renderer.setStyle(checkBox, 'cursor', 'pointer');
      this.renderer.listen(Hrow, 'click', (event) => { this.onSelectKpiFilter(fkey, event,checkBox,filterInput) });
      
      this.renderer.appendChild(Hcell, this.renderer.createText(this.kpiFilters[fkey]["name"]));
      // this.renderer.appendChild(Hcell, this.renderer.createText(fkey));
      this.renderer.appendChild(moreFiltersContainer, Hrow);
    })    
  }

  drawFilters(elmRef:HTMLDivElement, data:any, parent:string, parentElement:HTMLDivElement){
    
    const Hrow = this.renderer.createElement('div');
    const HrowContent = this.renderer.createElement('div');
    const empty = this.renderer.createElement('div');
    this.renderer.appendChild(elmRef, Hrow);
    this.renderer.addClass(Hrow, 'tRowHead');
    this.renderer.addClass(empty, 'hCell');
    this.renderer.addClass(HrowContent, 'tRowHead');
      Object.keys(data).forEach(key =>  {
        let parentKey = key+"$$$$"+data[key]["name"]
        if(data[key]['type'] == 'level' && data[key]['options']){
          const Hcell = this.renderer.createElement('div');
          const HcellItem = this.renderer.createElement('div');
          const HcellCont = this.renderer.createElement('div');
          const rowsToggle = this.renderer.createElement('div');
          const toggleIcon = this.renderer.createElement('i');
          const checkBox = this.renderer.createElement('INPUT');
          const HcellName = this.renderer.createElement('div');
          checkBox.setAttribute("type", "checkbox");
          this.renderer.addClass(checkBox, 'mat-checkbox');
          this.renderer.addClass(checkBox, 'filter-input-checkbox');
          this.renderer.addClass(toggleIcon, 'material-icons');
          this.renderer.addClass(toggleIcon, 'row-toggle-icon');
          this.renderer.addClass(Hcell, 'hCell');
          this.renderer.addClass(HcellCont, 'hCellcontent');
          this.renderer.addClass(HcellItem, 'hCellItem');
          this.renderer.addClass(HcellName, 'hCellName');
          this.renderer.appendChild(Hrow, Hcell);
          this.renderer.appendChild(Hcell, HcellItem);
          this.renderer.appendChild(HcellItem, checkBox);
          this.renderer.appendChild(HcellName, this.renderer.createText(data[key]['name']));
          // this.renderer.appendChild(HcellName, this.renderer.createText(key));
          this.renderer.appendChild(HcellItem, HcellName);
          this.renderer.appendChild(HcellItem, rowsToggle);
          this.renderer.addClass(Hrow, 'filter-item');
          this.renderer.appendChild(rowsToggle, toggleIcon);
          this.renderer.appendChild(toggleIcon, this.renderer.createText('arrow_drop_down'));
          checkBox.setAttribute("datakey", parent+'--.-'+parentKey);
          // checkBox.setAttribute("datakey", parent+'--.-'+key);
          // this.renderer.addClass(checkBox, key)
          this.renderer.addClass(checkBox, key.replace(/\s+/g, '-').trim())
          this.renderer.setStyle(HcellItem, 'cursor', 'pointer');
          this.renderer.setStyle(checkBox, 'cursor', 'pointer');
          // this.renderer.listen(HcellItem, 'click', (event) => { this.onSelectFilter(parent+'--.-'+key, event,checkBox,parentElement,HcellCont) });
          this.renderer.listen(HcellItem, 'click', (event) => { this.onSelectFilter(parent+'--.-'+parentKey, event,checkBox,parentElement,HcellCont) });
          this.renderer.appendChild(Hcell, HcellCont);
          this.renderer.setStyle(HcellCont, 'display','none');
          this.renderer.setStyle(rowsToggle, 'cursor', 'pointer');
          this.renderer.listen(rowsToggle, 'click', (event) => { this.toggleRow(toggleIcon, HcellCont, event) });
          this.drawFilters(HcellCont, data[key]['options'],parent+'--.-'+parentKey,HcellItem);
        }
        
        if(data[key]['type'] == 'option' || !data[key]['options']){
          const Hcell = this.renderer.createElement('div');
          const Hrow = this.renderer.createElement('div');
          const checkBox = this.renderer.createElement('INPUT');
          checkBox.setAttribute("type", "checkbox");
          this.renderer.addClass(checkBox, 'mat-checkbox');
          this.renderer.addClass(checkBox, 'filter-input-checkbox');
          this.renderer.addClass(elmRef, 'trow');
          this.renderer.appendChild(Hrow, checkBox);
          this.renderer.appendChild(Hrow, Hcell);
          this.renderer.addClass(Hrow, 'filter-item');
          // checkBox.setAttribute("datakey", parent+'--.-'+key);
          checkBox.setAttribute("datakey", parent+'--.-'+parentKey);
          this.renderer.setStyle(Hrow, 'cursor', 'pointer');
          this.renderer.setStyle(checkBox, 'cursor', 'pointer');
          // this.renderer.listen(Hrow, 'click', (event) => { this.onSelectFilter(parent+'--.-'+key, event,checkBox,parentElement) });
          this.renderer.listen(Hrow, 'click', (event) => { this.onSelectFilter(parent+'--.-'+parentKey, event,checkBox,parentElement) });
  
          this.renderer.appendChild(Hcell, this.renderer.createText(data[key]['name']));
          // this.renderer.appendChild(Hcell, this.renderer.createText(key));
          this.renderer.appendChild(elmRef, Hrow);
        }
  
      });
    
   

  }

  toggleRow(toggleIcon:HTMLElement, contentRef:HTMLDivElement, event, id?:string){
    event.stopPropagation();
    const icon = toggleIcon.innerText == 'arrow_drop_up' ? 'arrow_drop_down' : 'arrow_drop_up';
    this.renderer.setProperty(toggleIcon, 'innerHTML','');
    this.renderer.appendChild(toggleIcon, this.renderer.createText(icon));
    if(id){
      if (id == 'outer-parent') {
        let outerFilterToggel = document.getElementsByClassName('outer-filters-toggel');
        let outerFiltersToggelIcon = document.getElementsByClassName('outer-filters-toggel-icon');
        for (let i = 0; i < outerFilterToggel.length; i++) {
          this.renderer.setStyle(outerFilterToggel[i], 'display','none');
        }
        for (let j = 0; j < outerFiltersToggelIcon.length; j++) {
          this.renderer.setProperty(outerFiltersToggelIcon[j], 'innerHTML','');
          this.renderer.appendChild(outerFiltersToggelIcon[j], this.renderer.createText('arrow_drop_down'));
        }

        this.renderer.setProperty(toggleIcon, 'innerHTML','');
        this.renderer.appendChild(toggleIcon, this.renderer.createText(icon));
        if(toggleIcon.innerText == 'arrow_drop_up'){
          this.renderer.setStyle(contentRef, 'display','block');
        }else{
          this.renderer.setStyle(contentRef, 'display','none');
        }
      }else{
        let tableRef:HTMLElement = document.getElementById(id);
        if(toggleIcon.innerText == 'arrow_drop_up'){
          tableRef.setAttribute('style','display:block')
        }else{
          tableRef.setAttribute('style','display:none')
        }
      }
    }else{
      if(toggleIcon.innerText == 'arrow_drop_up'){
        this.renderer.setStyle(contentRef, 'display','block');
      }else{
        this.renderer.setStyle(contentRef, 'display','none');
      }
    }
  }
  editSheetName(){
    this.evService.selectedSheetName = JSON.parse(JSON.stringify(this.evService.selectedSheet.value.sheet_name));
    this.evService.isSheetnameEdit = true;
    setTimeout(() => {
      let sheetNameElemente = <HTMLInputElement> document.getElementById("sheet-name");
      sheetNameElemente.focus();
    }, 50);
  }
  editSheetNameFouseOut(){
    // this.evService.renameSheet();
    if (this.evService.selectedSheetName === this.evService.selectedSheet.value.sheet_name) {
      this.evService.isSheetnameEdit = false;
    }else{
      this.evService.selectedSheet.value["new_sheet_name"] = this.evService.selectedSheetName 
      this.evService.renameSheet()
    }
  }
  onSubmit(){
    const filterRequestData = {};
    this.selectedFilter.map(item => item.split('--.-')).forEach((parts) => {
        let map = filterRequestData;
        for(const itemKey of parts) {
          let item = itemKey.split('$$$$')[0]
          map[item] = map[item] || {};
          if (Object.keys(map[item]).length > 0) {
            map[item]['type'] = 'level';
          }else{
            map[item]['type'] = 'option';
          }

          map[item]['options'] = map[item]['options'] || {};
          map = map[item]['options'];
        }
    });
    this.evService.selectedFilter = filterRequestData;
    this.evService.selectedKpis = {}
    this.selectedKpiKeys.forEach(key => {
      this.evService.selectedKpis[key] = this.kpiFilters[key];
    });
    // this.selectedKpiFilter.forEach(kpi => {
    //   this.evService.selectedKpis[kpi.key] = kpi.value;
    // });
      this.evService.getExcelData();
  }

  closeAllToggel(event){
    event.stopPropagation();
    let outerFilterToggel = document.getElementsByClassName('outer-filters-toggel');
        let outerFiltersToggelIcon = document.getElementsByClassName('outer-filters-toggel-icon');
        for (let i = 0; i < outerFilterToggel.length; i++) {
          this.renderer.setStyle(outerFilterToggel[i], 'display','none');
        }
        for (let j = 0; j < outerFiltersToggelIcon.length; j++) {
          this.renderer.setProperty(outerFiltersToggelIcon[j], 'innerHTML','');
          this.renderer.appendChild(outerFiltersToggelIcon[j], this.renderer.createText('arrow_drop_down'));
        }
  }

  submitTracker(){
    this.stopTimer();
    let data = {}
    data['uuid'] = this.reportService.fileUUID;
    data['file_type'] = 'repo';
    data['viewtime'] = this.interval;
    data['session_id'] = this.evService.trackerSessionId ;
    data['action'] = 'exit';
    if (data['uuid'] && data['uuid'] != '') {
      this.trackerService.submitTracker(data);
    }
  }

  editSheet(){
    if (this.evService.selectedSheet.value.sheet_id) {
      this.evService.closeAllTabs();
      this.evService.isSheetEditComponent = true;
    }else{
      this.notifier.notify("error","Sheet not yet created!")
    }
  }
  deleteSheet(){
    // this.evService.selectedSheet.value.sheet_id
    this.evService.closeAllTabs();
    if (this.evService.selectedSheet.value.sheet_id) {
      let body = {"table_id":this.evService.selectedSheet.value.sheet_id}
      this.repoService.deleteSheet(body).subscribe(
        result =>{
          if (result["status"] == 1) {
            this.notifier.notify("success","Sheet deleted successfully");
            this.evService.getFilterOptions();
            this.evService.removekpiViewerMerge();
          }else{
            this.notifier.notify("error","Something went wrong!");
          }
        }
      )
    }else{
      this.evService.getFilterOptions()
    }
  }

  openDownloadSettingPanel(){
    this.evService.isDownloadSettingComponent = true;
  }


  dataSourceComponent(){
    this.evService.isDataSourceToplineComponent = true;
  }

  openTableReorder(event){
    this.evService.openKPIReorder();
  }

  openMergeToplineComponent(){
    this.evService.isMergeToplineComponent = true;
  }


}
